import AddPaymentMethod from "./AddPaymentMethod"
export default AddPaymentMethod
